import * as momentRoutines from '../momentRoutines';
import * as momentSelectors from '../selectors';
import * as paths from '../../../Providers/paths';
import * as rootSelectors from '../../../selectors/root';
import * as toastRoutines from '../../../sagas/routines/toastRoutines';
import { call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { deleteFileFromStorageSaga } from '../../../sagas/filesSaga';
import { rsf } from '../../../globals/firebase';
import { sendStringSaga } from '../../../sagas/filesSaga';
import getTypeFromBase64 from '../../../helpers/getTypeFromBase64'
function* toggleMomentConfigSettingSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const { ...payload } = action.payload;
    let name = Object.keys(payload)[0]; //Let's get the key name
    let updated = {
        [name]: payload[name] === true ? true : false,
    }; //Helps ensure value only exists in fb if not null

    yield fork(rsf.database.patch, paths.moduleConfig(activeEvent, 'feed', 'Moments'), updated, {
        successActionCreator: momentRoutines.toggleMomentConfigSetting.success,
        failureActionCreator: momentRoutines.toggleMomentConfigSetting.failure,
    });
}

function* createMomentFilterSaga(action) {
    yield put(
        toastRoutines.triggerToast({
            content: 'Adding new filter...',
            options: { type: 'info', autoClose: false },
        }),
    );
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const { filter } = action.payload;
    const type = getTypeFromBase64(filter)
    const filter_id = yield call(
        rsf.database.create,
        paths.moduleConfig(activeEvent, 'feed', 'Moments', 'imageFilters'),
        { index: 0 },
    );
    const filePath = paths.storage_moment_filters(activeEvent, filter_id) + `filter.${type}`;
    try {
    const downloadablePath = yield call(sendStringSaga, { filePath, imageURL: filter });
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'feed', 'Moments', 'imageFilters', filter_id), {
            imageURL: downloadablePath,
        });
        yield put(toastRoutines.dismissToast());
        yield put(momentRoutines.createMomentFilter.success());
        yield put(toastRoutines.setToastSuccess('Filter added!'));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        yield put(momentRoutines.createMomentFilter.failure(error));
        yield put(toastRoutines.setToastError('Error adding filter!'));
    }
}

function* updateMomentFilterSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const { id, index } = action.payload;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'feed', 'Moments', 'imageFilters', id), {
            index,
        });
        yield put(momentRoutines.updateMomentFilter.success());
    } catch (error) {
        yield put(momentRoutines.updateMomentFilter.failure(error));
    }
}

function* deleteMomentFilterSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const filters = yield select(momentSelectors.makeMomentFilters);
    let currentFilterImage = filters[action.payload].imageURL;
    try {
        if (currentFilterImage)
            yield call(
                deleteFileFromStorageSaga,
                currentFilterImage,
                paths.storage_moment_filters(activeEvent, action.payload),
            );
        yield call(
            rsf.database.delete,
            paths.moduleConfig(activeEvent, 'feed', 'Moments', 'imageFilters', action.payload),
        );
        yield put(momentRoutines.deleteMomentFilter.success());
        yield put(toastRoutines.setToastSuccess('Filter removed!'));
    } catch (error) {
        yield put(momentRoutines.deleteMomentFilter.failure(error));
    }
}

function* syncMomentsConfigSaga() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleConfig(activeEvent, 'feed', 'Moments'), {
        successActionCreator: momentRoutines.syncMomentsConfig.success,
        failureActionCreator: momentRoutines.syncMomentsConfig.failure,
    });
}

export function* resetMomentsConfigSync() {
    yield put(momentRoutines.stopSyncingMomentsConfig.trigger());
    yield put(momentRoutines.syncMomentsConfig());
}

export default function* rootSaga() {
    yield takeEvery(momentRoutines.toggleMomentConfigSetting.TRIGGER, toggleMomentConfigSettingSaga);
    yield takeEvery(momentRoutines.createMomentFilter.TRIGGER, createMomentFilterSaga);
    yield takeEvery(momentRoutines.deleteMomentFilter.TRIGGER, deleteMomentFilterSaga);
    yield takeEvery(momentRoutines.updateMomentFilter.TRIGGER, updateMomentFilterSaga);

    while (yield take(momentRoutines.syncMomentsConfig.TRIGGER)) {
        const bgMomentsConfigSync = yield fork(syncMomentsConfigSaga);
        yield take(momentRoutines.stopSyncingMomentsConfig.TRIGGER);
        yield cancel(bgMomentsConfigSync);
    }
}
